var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStructure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25200_5932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8546 17.341L12.6607 0.347491C12.3558 -0.115408 11.6747 -0.116252 11.3693 0.347491L0.17539 17.341C-0.0807442 17.7298 0.0625374 18.2568 0.482443 18.4614C12.675 24.4021 11.7536 23.9936 12.015 23.9936C12.2756 23.9936 11.3327 24.4129 23.5476 18.4614C23.9661 18.2575 24.1115 17.731 23.8546 17.341ZM12.7882 3.35204L21.348 16.3468L12.7882 13.5575V3.35204ZM11.2418 13.5575L2.68197 16.3468L11.2418 3.35204V13.5575ZM11.2418 15.1838V21.9837L2.87894 17.9089L11.2418 15.1838ZM12.7882 15.1838L21.1511 17.9089L12.7882 21.9837V15.1838Z",
    fill: "CurrentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25200_5932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "CurrentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStructure);
export default __webpack_public_path__ + "static/media/icon-structure.488a5cea07c2b0be382092cc3bab8e11.svg";
export { ForwardRef as ReactComponent };